import React from 'react'
import { WIDGET_TYPES } from '../../constants/widgetTypes'
import WidgetTypeIcon from './WidgetTypeIcon'
import styles from './WidgetTypeSelector.module.scss'

interface WidgetTypeSelectorProps {
  value: string
  onChange: (code: string) => void
  disabled?: boolean
}

const WidgetTypeSelector: React.FC<WidgetTypeSelectorProps> = ({ value, onChange, disabled }) => (
  <div className={styles.cards}>
    {WIDGET_TYPES.map(wt => (
      <button
        key={wt.code}
        type="button"
        className={`${styles.card} ${value === wt.code ? styles.cardActive : ''}`}
        onClick={() => onChange(wt.code)}
        disabled={disabled}
        title={wt.label}
      >
        <div className={styles.icon}>
          <WidgetTypeIcon code={wt.code} size={24} />
        </div>
        <div className={styles.label}>{wt.label}</div>
      </button>
    ))}
  </div>
)

export default WidgetTypeSelector
